"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeleportDao = void 0;
const tools_1 = require("../utils/tools");
const wrapper_1 = require("./wrapper");
class TeleportDao {
    constructor(testnet = false) {
        const baseUrl = testnet
            ? "https://testnet.api.teleportdao.xyz/api"
            : "https://api.teleportdao.xyz/api";
        this.api = (0, tools_1.getAxiosInstance)({
            baseUrl,
            headers: {},
            timeout: 3 * 60000,
        });
    }
    getLockers(network) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.api.get("/v1/teleswap/lockers", {
                params: {
                    network,
                },
            })).data.data.lockers;
        });
    }
    selectLocker(network, amount, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = (yield this.api.get(`/v1/teleswap/select-locker/${network}`, {
                params: {
                    amount,
                    type,
                },
            })).data;
            return data.data;
        });
    }
    getAllFeeParams(network) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = (yield this.api.get(`/v1/teleswap/utils/fee-params/${network}`, {}))
                .data;
            return data.data;
        });
    }
    getUtxos(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = (yield this.api.get(`/v1/proxy/get-utxo/${address}`)).data;
            const utxos = result.data;
            return utxos;
        });
    }
    getNetworkRpc() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = (yield this.api.get(`/v1/utils/get-evm-networks-rpc`)).data;
            const networks = result.data;
            return networks;
        });
    }
    getAcrossFee(token, amount, destinationChainId, originChainId, message, recipient) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = (yield this.api.get(`/v1/proxy/get-across-fee`, {
                params: {
                    token,
                    destinationChainId,
                    amount,
                    originChainId,
                    message,
                    recipient,
                },
            })).data;
            const networks = result.data;
            return networks;
        });
    }
    getRequests(userAddresses, input) {
        return __awaiter(this, void 0, void 0, function* () {
            if (userAddresses.length === 0)
                throw new Error("no address provided");
            const defaultConfig = { filter: "done", limit: 10, offset: 0 };
            const config = Object.assign(Object.assign({}, defaultConfig), (input || {}));
            const result = (yield this.api.get(`/v2/teleswap/requests`, {
                params: config,
            })).data;
            return result.data;
        });
    }
    getAllRequests(input) {
        return __awaiter(this, void 0, void 0, function* () {
            const defaultConfig = { filter: "done", limit: 10, offset: 0 };
            const config = Object.assign(Object.assign({}, defaultConfig), (input || {}));
            const result = (yield this.api.get(`/v2/teleswap/requests`, {
                params: config,
            })).data;
            return result.data;
        });
    }
    getWaitingRequests(address, { limit = 10, offset = 0, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = (yield this.api.get(`/v1/teleswap/cross-chain/waiting-request/${address}`, {
                params: {
                    limit,
                    offset,
                },
            })).data;
            return result.data.map((r) => (0, wrapper_1.waitingRequestWrapper)(r));
        });
    }
    getRequestByTxId(txId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = (yield this.api.get(`/v2/teleswap/requests/tx/${txId}`)).data;
            return result.data;
        });
    }
    getWaitingRequestByTxId(txId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = (yield this.api.get(`/v2/teleswap/requests/waiting/tx/${txId}`)).data;
            return result.data ? (0, wrapper_1.waitingRequestWrapper)(result.data) : null;
        });
    }
    checkRequestStatusByTxId(txId) {
        return __awaiter(this, void 0, void 0, function* () {
            let res = yield this.getRequestByTxId(txId);
            if (!res)
                res = yield this.getWaitingRequestByTxId(txId);
            return res;
        });
    }
}
exports.TeleportDao = TeleportDao;
//# sourceMappingURL=index.js.map